import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

// Suppress specific React warning from third-party libraries
if (process.env.NODE_ENV === 'development') {
  const originalError = console.error;
  console.error = (...args) => {
    if (
      typeof args[0] === 'string' &&
      args[0].includes("Can't perform a React state update on a component that hasn't mounted yet")
    ) {
      // Ignore this warning - it's from third-party library providers
      return;
    }
    originalError.call(console, ...args);
  };
}

// Apply theme before React renders to prevent flash
const THEME_KEY = "evi-theme-mode";
const savedTheme = localStorage.getItem(THEME_KEY);
const isDark = savedTheme === "dark" ||
  (!savedTheme && window.matchMedia("(prefers-color-scheme: dark)").matches);

if (isDark) {
  document.documentElement.setAttribute("data-theme", "dark");
  document.body.setAttribute("data-theme", "dark");
  document.documentElement.classList.add("dark-mode");
  document.body.classList.add("dark-mode");
} else {
  document.documentElement.setAttribute("data-theme", "light");
  document.body.setAttribute("data-theme", "light");
}

const root = createRoot(document.getElementById("root"));
root.render(<App />);
